import regionReducer from './regionSlice';
import * as regionActions from './actions';
import * as regionSelector from './selector';

export {
  regionActions,
  regionSelector
}

export default regionReducer